import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { appVersionsApi, type AppKind, type AppVersionInput } from "@/api/appVersions.api";
import { queryKeys } from "@/utils/queryKeys";

export function useAppVersionsList() {
  return useQuery({
    queryKey: queryKeys.appVersions.list(),
    queryFn: appVersionsApi.list,
  });
}

export function useAppVersionHistory(app: AppKind) {
  return useQuery({
    queryKey: queryKeys.appVersions.history(app),
    queryFn: () => appVersionsApi.history(app),
  });
}

export function useUpdateAppVersion() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ app, ...payload }: { app: AppKind } & AppVersionInput) => appVersionsApi.update(app, payload),
    onSuccess: (_row, { app }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.appVersions.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.appVersions.history(app) });
    },
  });
}
